import React from "react";
import Flippy, { FrontSide, BackSide } from "react-flippy";

function Card(props) {
  // const Card = forwardRef((props, ref)=> {
  const { onFrontClicked, flipped, info, frontFace, backFace, matched, index } =
    props;
  // const ref = useRef();

  // const run = () => {
  //   ref.current.classList.add("jello-horizontal");
  //  }
  // console.log(info.matched);
  return (
    <div className={!matched ? "OraderItem" : "OraderItem jello-horizontal"}>
      <Flippy
        flipOnHover={false} // default false
        flipOnClick={false} // default false
        isFlipped={flipped}
        flipDirection="horizontal" // horizontal or vertical
        // ref={ref} // to use toggle method like ref.curret.toggle()
        // if you pass isFlipped prop component will be controlled component.
        // and other props, which will go to div
        style={{ width: "100%", height: "100%" }} /// these are optional style, it is not necessary
      >
        <FrontSide
          style={{
            backgroundImage: `url(${frontFace})`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
          }}
          onClick={() => {
            onFrontClicked(index, info.id);
          }}
        />
        <BackSide
          style={{
            backgroundImage: `url(${backFace})`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "28px",
          }}
        >
          <img
            src={info.image}
            alt={info.title}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
          />
        </BackSide>
      </Flippy>
    </div>
  );
}

export default Card;
